import React, { useState } from "react";
import "../../css/LoginScreen.css";
import { useNavigate } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {
	getValueFromDatabase,
	loginUser,
	forgotPassword,
} from "../../apiIntegration/databaseConnection";
import { setShopDetailsToLocalStorage } from "../../localstorage";

// Import your login API

export default function LoginScreen() {
	const [tab, setTab] = useState("customer");
	const [showPassword, setShowPassword] = useState(false);

	// Added states
	const [email, setEmail] = useState("");
	const [password, setPassword] = useState("");
	const [loading, setLoading] = useState(false);

	const navigate = useNavigate();

	// Handle Login
	const handleLogin = async () => {
		// Basic validation
		if (!email.trim()) {
			toast.error("Please enter your email address");
			return;
		}

		if (!password.trim()) {
			toast.error("Please enter your password");
			return;
		}

		try {
			setLoading(true);
			// Login API Call
			const userCred = await loginUser(email, password);
			const uid = userCred.user.uid;
			const shopDetails = await getValueFromDatabase(`shops`, uid);

			// Success Toast
			toast.success("Login successful!");
			setShopDetailsToLocalStorage(shopDetails); // save to localstorage
			// Redirect based on selected tab
			setTimeout(() => {
				if (tab === "shop") {
					navigate("/shop-dashboard");
				} else {
					navigate("/");
				}
			}, 1000);
		} catch (error) {
			console.error("Login Error:", error);

			// Firebase/Auth error handling
			switch (error.code) {
				case "auth/user-not-found":
					toast.error("No account found with this email");
					break;

				case "auth/wrong-password":
					toast.error("Incorrect password");
					break;

				case "auth/invalid-email":
					toast.error("Invalid email address");
					break;

				case "auth/invalid-credential":
					toast.error("Invalid email or password");
					break;

				case "auth/too-many-requests":
					toast.error(
						"Too many failed attempts. Please try again later",
					);
					break;

				default:
					toast.error("Login failed. Please try again");
					break;
			}
		} finally {
			setLoading(false);
		}
	};

	/* ======================================================
   FORGOT PASSWORD
====================================================== */

	const handleForgotPassword = async () => {
		if (!email.trim()) {
			toast.error("Please enter your email address");
			return;
		}

		try {
			setLoading(true);

			await forgotPassword(email);

			toast.success(
				"Password reset email sent check your email or spam folder.",
			);
		} catch (error) {
			console.log(error);

			switch (error.code) {
				case "auth/user-not-found":
					toast.error("No account found with this email");
					break;

				case "auth/invalid-email":
					toast.error("Invalid email address");
					break;

				default:
					toast.error("Failed to send reset email");
					break;
			}
		} finally {
			setLoading(false);
		}
	};

	return (
		<div className="login-container">
			{/* Toast Container */}
			<ToastContainer
				position="top-right"
				autoClose={3000}
				hideProgressBar={false}
				closeOnClick
				pauseOnHover
				theme="light"
			/>

			<div className="text-center mb-4">
				<h1 className="brand">DigitalConcierge</h1>
				<p className="subtitle">
					Discover exclusive nearby deals and offers.
				</p>
			</div>

			<div className="login-card">
				<div className="pb-2">
					<h5>Login as </h5>
				</div>
				{/* Tabs */}
				<div className="tab-switch">
					<button
						className={tab === "customer" ? "active" : ""}
						onClick={() => setTab("customer")}
					>
						Customer
					</button>

					<button
						className={tab === "shop" ? "active" : ""}
						onClick={() => setTab("shop")}
					>
						Shop Owner
					</button>
				</div>

				{/* Email */}
				<div className="form-group">
					<div className="d-flex justify-content-between">
						<label>EMAIL ADDRESS</label>
					</div>

					<div className="input-box">
						<i className="fas fa-envelope"></i>

						<input
							type="email"
							placeholder="name@example.com"
							value={email}
							onChange={(e) => setEmail(e.target.value)}
						/>
					</div>
				</div>

				{/* Password */}
				<div className="form-group">
					<div className="d-flex justify-content-between">
						<label>PASSWORD</label>
					</div>

					<div className="input-box">
						<i className="fas fa-lock"></i>

						<input
							type={showPassword ? "text" : "password"}
							placeholder="••••••••"
							value={password}
							onChange={(e) => setPassword(e.target.value)}
							onKeyDown={(e) => {
								if (e.key === "Enter") {
									handleLogin();
								}
							}}
						/>

						<i
							className={`fas ${
								showPassword ? "fa-eye-slash" : "fa-eye"
							} toggle-eye`}
							onClick={() => setShowPassword(!showPassword)}
						></i>
					</div>
				</div>

				{/* Sign In */}
				<button
					className="btn btn-primary w-100 sign-btn"
					onClick={handleLogin}
					disabled={loading}
				>
					{loading ? "Signing In..." : "Sign In"}
				</button>

				<div className="text-left pt-3">
					<span
						className="forgot"
						onClick={handleForgotPassword}
						style={{
							cursor: "pointer",
							color: "#0d6efd",
							fontWeight: "600",
						}}
					>
						Forgot Password?
					</span>
				</div>
			</div>

			{/* Bottom */}
			<div className="bottom-text text-center">
				{/* <p>
					Don't have an account? <span className="link">Sign up</span>
				</p> */}

				<button
					onClick={() => navigate("/register-screen")}
					className="register-btn"
				>
					Register as a Shop Owner →
				</button>

				<small className="secure">🔒 Secure Encryption</small>
			</div>
		</div>
	);
}
